$(document).ready(function() {

    $('.hero').not('.slick-initialized').slick({
        arrows: eval($('#wm_heroes_setup_arrows').val()),
        dots: eval($('#wm_heroes_setup_dots').val()),
        infinite: true,
        autoplay: true,
        cssEase: 'linear',
        speed: 900,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        pauseOnFocus: false,
        adaptiveHeight: false,
    });

    $('.pub-gallery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.slider-nav'
    });

    $('.slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true
    });

    $('.offers_static_block').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
        ]
      
    });

    $('.image-carousel-slides').slick({
        arrows: eval($('#image_carousel_setup_arrows').val()),
        dots: eval($('#image_carousel_setup_dots').val()),
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        speed: 900,
        centerPadding: '20%',
        centerMode: true,
        customPaging: function (slider, i) {
            return '<button type="button" />';
        }
    });

    $('.menu-btn').click(function() {
        $('.main-nav').addClass('active');
        $('#menu-main-menu').addClass('active');
    });

    $('.close-menu').click(function() {
        $('.main-nav').removeClass('active');
        $('#menu-main-menu').removeClass('active');
    });

    $('.menu-item-has-children').unbind('click');
    $('.menu-item-has-children').click(function() {
        $(this).children('.dropdown').toggleClass('active');
        $(this).children('.sub-menu').toggleClass('active');
        $(this).toggleClass('active');
    });

    $('.filter-head').click(function() {
        $(this).toggleClass('active');
        $('.search-bar').toggleClass('active');
        $('.category-filters').toggleClass('active');
    });

    $('.table-iframe').click(function(e) {
        e.preventDefault();
        var $designmynight_site_id  = $(this).data('designmynight_site_id');
        if($designmynight_site_id){
            $('#table-book-designmynight').addClass('active');
        }else{
            $('#table-book-new').addClass('active');
        }
    });

    $('.close-iframe').click(function() {
        $('.table-book-wrap').removeClass('active');
    });

    $('.close-popup').click(function() {
        $('.popup-wrap').removeClass('enable-popup');
    });

    $('.form-nav-button').click(function() {
        $('.form-popup-wrap').addClass('active');
    });

    $('.form-popup-close').click(function() {
        $('.form-popup-wrap').removeClass('active');
    });

    var scrollTop = 0;
    $(window).scroll(function() {
        scrollTop = $(window).scrollTop();
        // $('.counter').html(scrollTop);

        if (scrollTop >= 80) {
            $('.page-head').addClass('scrolled-nav');
        } else if (scrollTop < 80) {
            $('.page-head').removeClass('scrolled-nav');
        }
    });
    $('.hero-book').click(function() {
        $('.hero-popup').addClass('active');
    });

    $('.form-close').click(function() {
        $('.hero-popup').removeClass('active');
    });

    if($('.bg-ctas').length > 1){
        $('.bg-ctas').eq(0).css('marginBottom', '-1px');
        $('.bg-ctas').eq(1).children('ul').css('width', '50%').css('margin', 'auto');
    }

});